/*
 * Copyright (C) 2021 Airfordable, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

/**
 * Given a string it return only the number of that
 * Ex: "(123) 123 123" => 123123123
 */
const onlyDigits = (str: string) => str.replace(/[^0-9]/gm, '');

export { onlyDigits };
